/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyIdentityCountryCapabilityResource
 */
export interface CompanyIdentityCountryCapabilityResource {
    /**
     * ISO-3166 alpha-2 country code.
     * @type {string}
     * @memberof CompanyIdentityCountryCapabilityResource
     */
    countryCode: string;
    /**
     * Ordered list of identifier types this country supports, mirroring the order of
     * `RegistrationNumberMatcher`s declared for the country.
     * 
     * @type {Array<string>}
     * @memberof CompanyIdentityCountryCapabilityResource
     */
    supportedIdentifierTypes: Array<string>;
    /**
     * True iff at least one of the supported identifier types is regional (currently only
     * German Handelsregister, `GERMANY_HRN`). When true, the create form must surface a
     * region-code input that is required only for the regional type(s); the backend remains
     * the source of truth for which (type, regionCode) combinations are valid.
     * 
     * @type {boolean}
     * @memberof CompanyIdentityCountryCapabilityResource
     */
    supportsRegionCode: boolean;
}

/**
 * Check if a given object implements the CompanyIdentityCountryCapabilityResource interface.
 */
export function instanceOfCompanyIdentityCountryCapabilityResource(value: object): value is CompanyIdentityCountryCapabilityResource {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('supportedIdentifierTypes' in value) || value['supportedIdentifierTypes'] === undefined) return false;
    if (!('supportsRegionCode' in value) || value['supportsRegionCode'] === undefined) return false;
    return true;
}

export function CompanyIdentityCountryCapabilityResourceFromJSON(json: any): CompanyIdentityCountryCapabilityResource {
    return CompanyIdentityCountryCapabilityResourceFromJSONTyped(json, false);
}

export function CompanyIdentityCountryCapabilityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityCountryCapabilityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'supportedIdentifierTypes': json['supportedIdentifierTypes'],
        'supportsRegionCode': json['supportsRegionCode'],
    };
}

export function CompanyIdentityCountryCapabilityResourceToJSON(value?: CompanyIdentityCountryCapabilityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'supportedIdentifierTypes': value['supportedIdentifierTypes'],
        'supportsRegionCode': value['supportsRegionCode'],
    };
}

